import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_HEALTH_CONDITIONS = 'healthConditions'

export const overviewSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_HEALTH_CONDITIONS]: z.string().optional(),
})
